import { useResettableMutation } from "apollo-hooks-extended";
import { gql } from "@src/__generated__";
import {
  DeleteDocumentDetailsMutation,
  DeleteDocumentDetailsMutationVariables,
} from "@src/__generated__/graphql";

const DELETE_DOCUMENT = gql(`
  mutation DeleteDocumentDetails($id: String!) {
    deleteDocument(id: $id)
  }
`);

export const useDeleteDocument = () => {
  const [
    deleteDocument,
    {
      data: deleteDocumentResponse,
      loading: deleteDocumentLoading,
      reset: resetDeleteDocument,
    },
  ] = useResettableMutation<
    DeleteDocumentDetailsMutation,
    DeleteDocumentDetailsMutationVariables
  >(DELETE_DOCUMENT, {
    onCompleted: () => {
      resetDeleteDocument();
    },
  });

  return {
    deleteDocument,
    deleteDocumentLoading,
    deleteDocumentResponse,
  };
};
